module.exports = __webpack_public_path__ + "static/media/xls.13756ea7.png";